import React from 'react';
import Color from 'color';
import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode
  color: string;
  lighten?: number;
}

export const Tag: React.FC<Props> = ({
  children,
  color,
  lighten = 0.5,
}) => (
  <div
    className={styles.container}
    style={{
      backgroundColor: Color(color).lighten(lighten).toString(),
    }}
  >
    <span
      className={styles.tagSpan}
      style={{
        color,
      }}
    >
      {children}
    </span>
  </div>
);
